<template>
  <div class="page">
    <div class="page-toolbar bg-white shadow-sm p-3">
      <div class="d-flex align-items-center">
        <div class="mr-2">
          <h4 class="m-0">
            MDM Model
          </h4>
        </div>
      </div>
      <b-dropdown
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
      >
        <template #button-content>
          <font-awesome-icon :icon="['fas', 'ellipsis-v']" />
        </template>
        <b-dropdown-item
          v-for="(item,index) in menu"
          :key="index"
          @mouseover.native="toggleItem(index)"
          @mouseout.native="toggleItem(index)"
        >
          <span>{{ item.title }}
            <font-awesome-icon
              v-if="item.children"
              :icon="['fas', 'caret-down']"
            />
          </span>
          <div
            v-if="item.children"
            v-show="item.showSubMenu"
            class="sub-menu"
          >
            <b-dropdown-item
              v-for="(item,index) in item.children"
              :key="index"
              :active="isCurrentItem(item)"
              @click="changeEngine(item.title)"
            >
              {{ item.title }}
            </b-dropdown-item>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <ContentSpinner :show="loading" />
    <div
      v-if="!loading"
      id="pageContent"
      class="page-content graph-page"
    >
      <div class="svg-wrapper m-3">
        <div id="svgContent" />
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import Viz from 'viz.js';
import workerURL from 'file-loader!viz.js/full.render';
import * as d3 from 'd3';
import ContentSpinner from '../../core/components/ContentSpinner';

const {mapState, mapActions} = createNamespacedHelpers('mdmModel');

export default {
  name: 'MdmModel',
  components: {ContentSpinner},
  data: () => ({
    loading: false,
    viz: {
      currentEngine: null,
      defaultEngine: 'dot',
    },
    menu: [
      {
        title: 'Engine',
        showSubMenu: false,
        children: [
          {title: 'circo'},
          {title: 'dot'},
          {title: 'fdp'},
          {title: 'osage'},
          {title: 'twopi'},
          {title: 'neato'},
        ],
      },
    ],
  }),
  computed: {
    ...mapState(['modelData']),
  },
  methods: {
    ...mapActions(['getMdmModel']),
    async init(engine = null) {
      await this.getSvg(engine);
    },
    async getSvg(engine) {
      const viz = new Viz({workerURL});
      const vizEngine = engine ? engine : localStorage.getItem('vizEngine') || this.viz.defaultEngine;
      this.viz.currentEngine = vizEngine;

      viz.renderSVGElement(this.modelData, {engine: vizEngine})
        .then((element) => {
          element.id = 'svgContent';
          d3.select('#svgContent').node().replaceWith(element);
        });
    },
    async changeEngine(engine) {
      localStorage.setItem('vizEngine', engine);
      await this.init(engine);
    },
    toggleItem(index) {
      if (this.menu[index].children) {
        this.menu[index].showSubMenu = !this.menu[index].showSubMenu;
      }
    },
    isCurrentItem(item) {
      return this.viz.currentEngine === item.title;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getMdmModel();
    await this.init();
    this.loading = false;
  },
};
</script>

<style lang="scss">
.sub-menu {
  position: absolute;
  min-width: 10rem;
  padding: .5rem 0;
  margin: .125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: .25rem;
}

.svg-wrapper {
  height: 96%;
  background: white;
}

#svgContent {
  height: 100%;
  background: white;
}

.dropdown-item svg {
  float: right;
}
</style>
